import { useRef } from 'react';

// How far a finger must travel sideways, and how much more sideways than up
// or down, for a swipe rather than a scroll.
const MIN_DISTANCE = 60;
const MIN_SLOPE = 1.5;

// Touches that start on these drive their own element instead: the video's
// timeline, the audio player, the PDF's pages, a text field.
const IGNORE = 'video, audio, input, textarea, [data-no-swipe]';

// A left or right swipe over the element, as the mobile app's memory pager
// pages: swiping left goes to the next memory, right to the previous one.
export const useHorizontalSwipe = (onNext: () => void, onPrev: () => void) => {
  const start = useRef<{ x: number; y: number } | null>(null);

  const onTouchStart = (e: React.TouchEvent) => {
    const target = e.target as HTMLElement;
    start.current =
      e.touches.length === 1 && !target.closest(IGNORE)
        ? { x: e.touches[0].clientX, y: e.touches[0].clientY }
        : null;
  };

  const onTouchEnd = (e: React.TouchEvent) => {
    const from = start.current;
    start.current = null;
    if (!from) return;
    const dx = e.changedTouches[0].clientX - from.x;
    const dy = e.changedTouches[0].clientY - from.y;
    const isSwipe =
      Math.abs(dx) >= MIN_DISTANCE && Math.abs(dx) >= Math.abs(dy) * MIN_SLOPE;
    if (!isSwipe) return;
    if (dx < 0) onNext();
    else onPrev();
  };

  return { onTouchStart, onTouchEnd };
};
